module.exports = __webpack_public_path__ + "static/media/mpm_li_1.cbfd19f8.png";